var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clicksign"},[(_vm.minuta && _vm.minuta.length)?_c('embed',{attrs:{"src":_vm.minuta}}):_vm._e(),(_vm.id && _vm.id.length)?_c('div',{attrs:{"id":"clicksign"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }